import { NavItem } from "@charphq/ui/components/layout/navigation/AppSidebar";
import {
  LayoutDashboard,
  Users,
  FolderOpen,
  Rocket,
  Smartphone,
  Settings,
  CreditCard,
  Calculator,
  Settings2,
  UserCog,
  Building2,
  ShieldCheck,
  HeartPulse,
  KeyRound,
  LifeBuoy,
  FlaskConical,
  Beaker,
  PackageOpen,
} from "lucide-react";

// Custom navigation items for the web app, grouped into sidebar sections.
export const WEB_NAV_ITEMS: NavItem[] = [
  { section: "Operations" },
  {
    id: "dashboard",
    label: "Dashboard",
    href: "/dashboard",
    requiresAuth: true,
    icon: LayoutDashboard,
  },
  {
    id: "customers",
    label: "Customers",
    href: "/customers",
    requiresAuth: true,
    icon: Users,
  },
  {
    id: "projects",
    label: "Projects",
    href: "/projects",
    requiresAuth: true,
    icon: FolderOpen,
  },
  {
    id: "deployments",
    label: "Deployments",
    href: "/deployments",
    requiresAuth: true,
    icon: Rocket,
  },

  { section: "Support" },
  {
    id: "support",
    label: "Support",
    href: "/support",
    requiresAuth: true,
    icon: LifeBuoy,
  },

  { section: "Devices" },
  {
    id: "devices",
    label: "Devices",
    href: "/devices",
    requiresAuth: true,
    icon: Smartphone,
  },
  {
    // A custody action on devices; the adoption queue is reached from the Deployments page.
    id: "return-to-stock",
    label: "Return to stock",
    href: "/devices/return-to-stock",
    requiresAuth: true,
    icon: PackageOpen,
  },
  {
    id: "sim-cards",
    label: "SIM Cards",
    href: "/sim-cards",
    requiresAuth: true,
    icon: CreditCard,
  },
  {
    id: "calibrations",
    label: "Calibrations",
    href: "/calibrations",
    requiresAuth: true,
    icon: Calculator,
  },
  {
    id: "configuration",
    label: "Configuration",
    href: "/configuration",
    requiresAuth: true,
    icon: Settings2,
  },

  { section: "Experimental" },
  {
    id: "psychrometrics",
    label: "Psychrometrics",
    href: "/psychrometrics",
    requiresAuth: true,
    icon: FlaskConical,
  },
  {
    // Six destinations collapsed into one row. Flat they would be a 43 % jump
    // in the rail's link count and push Admin below the fold.
    //
    // OTO-172 specified a new `{ section: "Labs" }`, but this "Experimental"
    // section already exists (OTO-167). A second section for the same idea
    // would be worse than reusing this one, so the group lives here. The
    // consequence: with the flag off, the section header survives because
    // Psychrometrics is not flagged — the group itself leaves no trace. That is
    // what "only Psychrometrics is showing" looked like before OTO-187 turned
    // the flag on everywhere.
    id: "experiments",
    label: "Experiments",
    icon: Beaker,
    requiresAuth: true,
    featureFlag: "experiments_gallery",
    children: [
      { id: "live-network", label: "Live Network", href: "/experiments/live-network" },
      { id: "seasonal-climate", label: "Seasonal Climate", href: "/experiments/seasonal-climate" },
      { id: "climate-tapestry", label: "Climate Tapestry", href: "/experiments/climate-tapestry" },
      { id: "comfort-streams", label: "Comfort Streams", href: "/experiments/comfort-streams" },
      { id: "climate-loop", label: "Climate Loop", href: "/experiments/climate-loop" },
      { id: "region-postcards", label: "Region Postcards", href: "/experiments/region-postcards" },
    ],
  },

  { section: "Admin" },
  {
    id: "users",
    label: "User Management",
    href: "/users",
    requiresAuth: true,
    requiredRoles: ["admin", "owner"],
    icon: UserCog,
  },
  {
    id: "organizations",
    label: "Organizations",
    href: "/organizations",
    requiresAuth: true,
    icon: Building2,
  },
  {
    id: "api-keys",
    label: "API Keys",
    href: "/api-keys",
    requiresAuth: true,
    // No requiredRoles: nav filtering keys off the GLOBAL role, which would hide this from
    // a non-super-admin org owner. The page gates management by the ACTIVE-org role instead.
    icon: KeyRound,
  },
  {
    id: "admin",
    label: "Admin",
    href: "/admin",
    requiresAuth: true,
    requiredRoles: ["admin", "owner"],
    icon: ShieldCheck,
  },
  {
    id: "system-health",
    label: "System Health",
    href: "/system-health",
    requiresAuth: true,
    icon: HeartPulse,
  },
  {
    id: "settings",
    label: "Settings",
    href: "/settings",
    requiresAuth: true,
    icon: Settings,
  },
];
